import { HomeTemplatesController } from './home-templates.controller'

function homeTemplates () {
  return {
    restrict: 'E',
    templateUrl: '/home/directives/home-templates/home-templates-directive.html?$$REVISION$$',
    controller: HomeTemplatesController
  }
}

export { homeTemplates }
